import { CommonModule } from '@angular/common';
import { Component, inject, signal, ViewChild, WritableSignal } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { JobsService } from '../../services/jobs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'app-users',
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent {
  private readonly _api = inject(JobsService);
  private readonly _snackBar = inject(MatSnackBar);
  @ViewChild(MatDrawer) drawer!: MatDrawer;

  data: WritableSignal<any[]> = signal([]);
  roles: WritableSignal<any[]> = signal([]);

  loaders: WritableSignal<any> = signal({
    users: false,
    addUser: false
  });

  userForm: FormGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required]),
    role: new FormControl(null, [Validators.required])
  })

  displayedColumns = [
    'name',
    'email',
    'role',
    'last_login'
  ];

  dataSource = new MatTableDataSource<any>();

  ngOnInit(): void {
    this.fetchUsers();
  }

  ngAfterViewInit(): void {
    this.dataSource.data = this.data();
  }

  toggleUsersLoader() {
    this.loaders.update((item) => ({
      ...item,
      users: !this.loaders().users
    }))
  }

  toggleAddUsersLoader() {
    this.loaders.update((item) => ({
      ...item,
      addUser: !this.loaders().addUser
    }))
  }

  getAvailableRoles() {
    if (this.roles().length) return;
    this._api.getRoles().subscribe({
      next: (res: any) => {
        this.roles.set(res.data);
      }
    })
  }

  fetchUsers() {
    this.toggleUsersLoader()
    this._api.getUsers()
      .pipe(finalize(() => (this.toggleUsersLoader())))
      .subscribe({
        next: (res: any) => {
          this.data.set(res.data);
          this.dataSource.data = this.data();
        },
        error: (err: any) => {
          this._snackBar.open(err?.error?.message || "Unable to fetch users")
        }
      })
  }

  addUser() {
    if (this.userForm.invalid) return;
    this.toggleAddUsersLoader();
    this._api.addUser(this.userForm.value)
      .pipe(finalize(() => (this.toggleAddUsersLoader())))
      .subscribe({
        next: (res: any) => {
          this._snackBar.open(res.message || "User added succesfully")
          this.clearForm();
          this.drawer.close();
          this.fetchUsers();
        },
        error: (err: any) => {
          this._snackBar.open(err?.error?.message || "Unable to add user")
        }
      })
  }

  clearForm() {
    this.userForm.reset();

    Object.keys(this.userForm.controls).forEach(key => {
      const control = this.userForm.get(key);
      if (control) {
        control.setErrors(null);
        control.markAsUntouched();
        control.markAsPristine();
      }
    });
  }
}
